export default {
  GET_AUTHINFO_REQUEST: '@@sso-auth-info/AUTHINFO_REQUEST',
  GET_AUTHINFO_SUCCESS: '@@sso-auth-info/AUTHINFO_SUCCESS',
  GET_AUTHINFO_ERROR: '@@sso-auth-info/AUTHINFO_ERROR',

  SET_CALLBACK_ERROR: '@@sso-auth-info/SET_CALLBACK_ERROR',
};
